export const SIDEBAR_WIDTH = 260;

export const COGNITO_CONFIG = {
  UserPoolId: 'us-east-1_BgiyvRzCN',
  ClientId: '6jh0pek0fjvel7fdlhrimkm9mn',
};

// Cognito groups granting access to the College Portal.
// - college_admin: full access to their institution's data
// - faculty_advisor: read-only on assigned students + dashboard
// - college_observer: dashboard + reports only (e.g. dean, accreditation)
export const ROLES = {
  ADMIN: 'college_admin',
  FACULTY: 'faculty_advisor',
  OBSERVER: 'college_observer',
};

// Any of these grants entry to the portal.
export const COLLEGE_GROUPS = [ROLES.ADMIN, ROLES.FACULTY, ROLES.OBSERVER];

// Sentinel for the billing-admin flag (NOT a Cognito group). Routes listing
// this in their permissions array require user.isBillingAdmin === true,
// regardless of role. Sidebar.js + App.js (RoleRoute) honor this specially.
export const BILLING_ADMIN = 'billing_admin';

// Per-role access matrix for routes. Used by RoleRoute in App.js and the
// sidebar nav rendering. The BILLING_ADMIN value above is a flag check,
// not a role match — see RoleRoute for the special-case handling.
export const ROUTE_PERMISSIONS = {
  '/': [ROLES.ADMIN, ROLES.FACULTY, ROLES.OBSERVER],
  '/students': [ROLES.ADMIN, ROLES.FACULTY],
  '/cohorts': [ROLES.ADMIN],
  '/credits': [ROLES.ADMIN, ROLES.FACULTY],
  '/reports': [ROLES.ADMIN, ROLES.OBSERVER],
  '/billing': [BILLING_ADMIN],
  '/settings': [ROLES.ADMIN],
};

// Invoice statuses for the billing page.
export const INVOICE_STATUSES = {
  paid: { label: 'Paid', color: '#16a34a' },
  pending: { label: 'Pending', color: '#d97706' },
  due: { label: 'Due', color: '#d97706' },
  overdue: { label: 'Overdue', color: '#dc2626' },
  draft: { label: 'Draft', color: '#6b7280' },
  void: { label: 'Void', color: '#9ca3af' },
};

export const STUDENT_STATUSES = {
  on_track: { label: 'On Track', color: '#16a34a' },
  at_risk: { label: 'At Risk', color: '#dc2626' },
  qualified: { label: 'Qualified', color: '#0d9488' },
  complete: { label: 'Complete', color: '#0d9488' },
  in_progress: { label: 'In Progress', color: '#2563eb' },
  not_met: { label: 'Not Met', color: '#9ca3af' },
  withdrawn: { label: 'Withdrawn', color: '#6b7280' },
  pending: { label: 'Pending', color: '#d97706' },
};

export const COHORT_STATUSES = {
  DRAFT: { label: 'Draft', color: '#6b7280' },
  ACTIVE: { label: 'Active', color: '#16a34a' },
  COMPLETED: { label: 'Completed', color: '#0d9488' },
};

// At what % of credit progress is a student "at risk" given their cohort
// is past the halfway point. UI-only — backend may also return its own flag.
export const AT_RISK_THRESHOLD_PCT = 50;
